// import { Mail, MapPin, Phone } from "lucide-react"

// // ContactPage.jsx
// export default function ContactPage() {
//     return (
//       <div className="min-h-screen bg-gray-50">
//         {/* Contact Hero */}
//         <section className="relative pt-32 pb-48 bg-gradient-to-r from-green-900 to-gray-900">
//           <div className="max-w-7xl mx-auto px-6 text-center">
//             <h1 className="text-5xl font-bold text-white mb-6">Get in Touch</h1>
//             <p className="text-xl text-gray-200 max-w-2xl mx-auto">
//               We're here to help you with your solar energy needs. Reach out for inquiries,
//               support, or partnership opportunities.
//             </p>
//           </div>
//         </section>
  
//         {/* Contact Content */}
//         <section className="py-20">
//           <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16">
//             {/* Contact Form */}
//             <div className="bg-white p-8 rounded-2xl shadow-xl">
//               <h2 className="text-3xl font-bold mb-8">Send Us a Message</h2>
//               <form className="space-y-6">
//                 <div>
//                   <label className="block text-gray-700 mb-2">Full Name</label>
//                   <input 
//                     type="text" 
//                     className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-green-500" 
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Email Address</label>
//                   <input 
//                     type="email" 
//                     className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-green-500" 
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Message</label>
//                   <textarea 
//                     rows="5"
//                     className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-green-500" 
//                   />
//                 </div>
//                 <button className="w-full py-4 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors">
//                   Send Message
//                 </button>
//               </form>
//             </div>
  
//             {/* Contact Info */}
//             <div className="space-y-8">
//               <div className="bg-white p-8 rounded-2xl shadow-xl">
//                 <h3 className="text-2xl font-bold mb-6">Contact Information</h3>
//                 <div className="space-y-4">
//                   <div className="flex items-center space-x-4">
//                     <MapPin className="h-6 w-6 text-green-600" />
//                     <span>123 Solar Street, Energy City, EC 12345</span>
//                   </div>
//                   <div className="flex items-center space-x-4">
//                     <Phone className="h-6 w-6 text-green-600" />
//                     <span>(555) 123-4567</span>
//                   </div>
//                   <div className="flex items-center space-x-4">
//                     <Mail className="h-6 w-6 text-green-600" />
//                     <span>contact@krikosh.com</span>
//                   </div>
//                 </div>
//               </div>
  
//               {/* Map */}
//               <div className="h-96 rounded-2xl overflow-hidden shadow-xl">
//                 <iframe 
//                   src="https://www.google.com/maps/embed"
//                   className="w-full h-full"
//                   title="Location Map"
//                 />
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>
//     )
//   }

  import React from 'react';
import { 
  Phone, 
  Mail, 
  Clock, 
  MapPin, 
  Facebook, 
  Linkedin, 
  Instagram,
  Building2,
  ArrowRight
} from 'lucide-react';
import Header from './Header';
import Footer from './Footer';

const ContactUs = () => {
  const locations = [
    {
      city: "Sydney",
      address: "123 Business Park Drive, Silverwater NSW 2128",
      phone: "02 1234 5678",
      email: "sydney@solmart.com.au"
    },
  ];

  const businessHours = [
    { day: "Monday - Friday", hours: "8:30 AM - 5:00 PM" },
    
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <Header />
      <div className="bg-gradient-to-br from-green-600 to-green-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="max-w-3xl">
            <h1 className="text-4xl font-bold mb-6">Contact Us</h1>
            <p className="text-lg opacity-90">
              Get in touch with our team for any inquiries about our products, services, or support. 
              We're here to help you with all your solar energy needs.
            </p>
          </div>
        </div>
      </div>

      {/* Main Contact Information */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid md:grid-cols-3 gap-8">
        {/* Phone */}
        <div className="bg-gray-50 rounded-xl p-8 text-center shadow-lg">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-green-100 rounded-full">
              <Phone className="w-6 h-6 text-green-600" />
            </div>
          </div>
          <h3 className="text-xl font-semibold mb-2">Call Us</h3>
          <p className="text-gray-600 mb-4">Speak directly with our team</p>
          <a
            href="tel:0435574562"
            className="text-xl font-bold text-green-600 hover:text-green-700 mb-2"
          >
            0435 574 562
          </a>
          <br />
          <a
            href="tel:0468438722"
            className="text-xl font-bold text-green-600 hover:text-green-700"
          >
            0468 438 722
          </a>
        </div>

        {/* Email */}
        <div className="bg-gray-50 rounded-xl p-8 text-center shadow-lg">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-green-100 rounded-full">
              <Mail className="w-6 h-6 text-green-600" />
            </div>
          </div>
          <h3 className="text-xl font-semibold mb-2">Email Us</h3>
          <p className="text-gray-600 mb-4">Send us your inquiries</p>
          <a
            href="mailto:info@solmart.com.au"
            className="text-xl font-bold text-green-600 hover:text-green-700"
          >
            order@krikosh.com.au
          </a>
        </div>

        {/* Business Hours */}
        <div className="bg-gray-50 rounded-xl p-8 text-center shadow-lg">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-green-100 rounded-full">
              <Clock className="w-6 h-6 text-green-600" />
            </div>
          </div>
          <h3 className="text-xl font-semibold mb-2">Business Hours</h3>
          <p className="text-gray-600 mb-4">We're here to serve you</p>
          <div className="space-y-2">
            {businessHours.map((schedule, index) => (
              <div key={index} className="text-sm">
                <span className="font-medium">{schedule.day}: </span>
                <span className="text-gray-600">{schedule.hours}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>

      {/* Locations */}
      {/* <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center mb-6">
              <Building2 className="w-8 h-8 text-green-600 mr-3" />
              <h2 className="text-2xl font-bold">Our Locations</h2>
            </div>
            <p className="text-gray-600">
              Find us in major cities across Australia
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {locations.map((location, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-xl font-semibold mb-4 flex items-center">
                  <MapPin className="w-5 h-5 text-green-500 mr-2" />
                  {location.city}
                </h3>
                <div className="space-y-3 text-gray-600">
                  <p>{location.address}</p>
                  <p>Phone: {location.phone}</p>
                  <p>Email: {location.email}</p>
                </div>
                <button className="mt-4 text-green-500 hover:text-green-600 flex items-center">
                  Get Directions <ArrowRight className="w-4 h-4 ml-1" />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* Social Media */}
      {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-6">Connect With Us</h2>
          <div className="flex justify-center space-x-6">
            <a href="#" className="p-3 bg-gray-50 rounded-full hover:bg-gray-100 transition-colors">
              <Facebook className="w-6 h-6 text-green-500" />
            </a>
            <a href="#" className="p-3 bg-gray-50 rounded-full hover:bg-gray-100 transition-colors">
              <Linkedin className="w-6 h-6 text-green-500" />
            </a>
            <a href="#" className="p-3 bg-gray-50 rounded-full hover:bg-gray-100 transition-colors">
              <Instagram className="w-6 h-6 text-green-500" />
            </a>
          </div>
        </div>
      </div> */}
      <Footer />
    </div>
  );
};

export default ContactUs;